export * from '../generated/graphql';
import type * as GQL from '../generated/graphql';

type Extract<T, P extends keyof T> = NonNullable<
  NonNullable<T[P]> extends unknown[] ? NonNullable<T[P]>[number] : T[P]
>;

// TODO: This is deprecated types. Please use graphql fragments instead

export type GetTrendsTrends = Extract<GQL.GetTrendsQuery, 'trends'>;

export type GetAreasByCoordinatesAreasByCoordinates = Extract<
  GQL.GetAreasByCoordinatesQuery,
  'areasByCoordinates'
>;
export type GetAreasByCoordinatesAreas = Extract<GetAreasByCoordinatesAreasByCoordinates, 'areas'>;

export type GetInfoByAreaOfferingsAmount = Extract<GQL.GetInfoByAreaQuery, 'offeringsAmount'>;

export type GetInfoByAreaInfoByArea = Extract<GQL.GetInfoByAreaQuery, 'infoByArea'>;

export type GetInfoByAreaSubAreasByArea = Extract<GQL.GetSubAreasByAreaQuery, 'subAreasByArea'>;
export type GetInfoByAreaSubAreas = GQL.SubArea;
export type GetInfoByAreaQueryCombined = GQL.GetInfoByAreaQuery & {
  subAreasByArea?: GQL.GetSubAreasByAreaQuery['subAreasByArea'];
};

export type GetInfoByAreaTopCities = Extract<GQL.GetInfoByAreaQuery, 'topCities'>;

export type GetNearbyAreasNearbyAreas = Extract<
  NonNullable<GQL.GetNearbyAreasQuery['nearbyAreasByArea']>,
  'nearbyAreas'
>;

export type GetLayersByCoordinatesLayersByCoordinates = Extract<
  GQL.GetLayersByCoordinatesQuery,
  'layersByCoordinates'
>;

export type GetPropertiesByCoordinatesProperties = Extract<
  GQL.GetPropertiesByCoordinatesQuery,
  'properties'
>;
export type GetPropertiesByCoordinates_Properties = Extract<
  GetPropertiesByCoordinatesProperties,
  'properties'
>;
